import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(function (config) {
  const token = localStorage.getItem("@App:token");
  config.headers["Authorization"] = token
    ? `Bearer ${token}`
    : config.headers["Authorization"];
  return config;
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (String(error?.code)?.match("ERR_NETWORK")) {
      // localStorage.removeItem("@App:user");
      // localStorage.removeItem("@App:token");
      // localStorage.clear();
      // window.location.replace('/logout');
    } else {
      return Promise.reject(error);
    }
  }
);